export const anchorLinks = [
  {
    anchor: 'team',
    alias: '#team',
    title: 'Redner',
  },
  {
    anchor: 'program',
    alias: '#program',
    title: 'Programm',
  },
  {
    anchor: 'address',
    alias: '#address',
    title: 'So finden Sie uns',
  },
];
